import { FC, ChangeEvent } from 'react';
import cx from 'classnames/bind';

import styles from './Checkbox.module.scss';

const cn = cx.bind(styles);

interface CheckboxProps {
  id: number;
  text: string;
  changeCheckboxValue: (e: ChangeEvent<HTMLInputElement>, id: number) => void;
  isDisabled?: (id: number) => boolean;
}

const Checkbox: FC<CheckboxProps> = ({
  id,
  text,
  changeCheckboxValue,
  isDisabled,
}) => (
  <label key={id} className={cn('label')}>
    <input
      onChange={(e) => changeCheckboxValue(e, id)}
      className={cn('input')}
      type="checkbox"
      disabled={isDisabled ? isDisabled(id) : false}
    />
    <span className={cn('checkbox')} />
    {text}
  </label>
);

export default Checkbox;
